import { get, BaseUrl } from './api'

/**
 *  @returns {Promise.<{userId:string,userName:string,email:string,firstName:string,lastName:string,phoneNumber:string,fullName:string,customerIds:Array.<string>,isSppUser:boolean,userProfileImage:string,customerUserRole:number}>}
 */
export const getUserProfile = async () => {
    return await get(`api/MyUser`, BaseUrl.Centerpoint);
}